import { Box, Select, MenuItem, Typography } from "@mui/material";

function LanguageSelector({ value, onChange }) {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 1,
        mb: 2,
      }}
    >
      <Typography
        sx={{
          fontWeight: 600,
          color: "#666",
          fontSize: "14px",
        }}
      >
        Language
      </Typography>

      <Select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        size="small"
        sx={{
          minWidth: 180,
          height: 40,
          borderRadius: 3,
          fontWeight: 600,

          background: "linear-gradient(135deg,#fff7ed,#ffe0b2)",
          boxShadow: "0 3px 10px rgba(0,0,0,0.08)",

          "& .MuiSelect-select": {
            display: "flex",
            alignItems: "center",
            gap: 1,
            paddingLeft: "12px",
          },

          "& fieldset": {
            border: "1px solid rgba(0,0,0,0.1)",
          },

          "&:hover fieldset": {
            borderColor: "#fb8c00",
          },

          "&.Mui-focused fieldset": {
            borderColor: "#f57c00",
          },
        }}
      >
        <MenuItem value="en">English</MenuItem>
        <MenuItem value="hi">हिंदी</MenuItem>
        <MenuItem value="mr">मराठी</MenuItem>
      </Select>
    </Box>
  );
}

export default LanguageSelector;